import InnerComponent from '@Components/Common/ViewPoPayment';
import orgContainer from '@Components/AppContainer';

const ViewVendorPayout = () => ((orgContainer(InnerComponent)));
export default ViewVendorPayout;
